export default __webpack_public_path__ + "static/media/JadedResearcher.f4925611.png";